import { Grid, Typography } from "@mui/material"
import { DataGrid } from "@mui/x-data-grid"
import { ExpenseMap } from "./Expense"
import { useEffect, useState } from "react"
import { getExpenseAnnualTotal, getExpensesFromMonzo, getIncomeAfterExpenses } from "../store/store"
import { useParams, useSearchParams } from "react-router-dom"
import dayjs from "dayjs"
import { useFinances } from "../store/FinancesContext"
import { MoneyTextFormat } from "../money"

function Monzo() {

    var { year } = useParams()
    var finances = useFinances()


    const remaining = getIncomeAfterExpenses(finances, parseInt(year))

    const [monzoTransactions, setMonzoTransactions] = useState([])

    useEffect(() => {
        async function fetchData() {
            getExpensesFromMonzo().then((r) => {
                setMonzoTransactions(r)
            })
        }

        fetchData()

    }, [])

    const monzoMap = {
        'healthbeauty': ['Personal care'],
        'holiday': ['Holidays'],
        'shopping': ['Shopping', 'Groceries'],
        'fuel': ['Transport'],
        'subscriptions': ['Subscriptions'],
        'clothing': ['Clothing'],
        'hobbies': ['Hobbies', 'Pets'],
        'homeimprovement': ['Home Improvement'],
        'disposable': ['Entertainment', 'General', 'Eating out'],
        'water': ['Yorkshire Water'],
        'energy': ['British Gas'],
        'counciltax': ['Kirklees Council'],
        'phone': ['Vodafone']
    }

    console.log(monzoTransactions)
    return <Grid container size={12} spacing={2}>
        <Grid item size={12}>
            <Typography variant='h6'>Categoroies</Typography>
        </Grid>
        <Grid item size={12}>
            <DataGrid autoHeight disableColumnResize disableColumnMenu disableRowSelectionOnClick columns={[
                {
                    field: 'id',
                    headerName: 'Category',
                    hide: true,
                    flex: 5
                },
                {
                    field: 'Planned',
                    flex: 10,
                    renderCell: (params) => {
                        return <MoneyTextFormat value={params.row.planned} />
                    }
                },
                {
                    field: 'To Date',
                    flex: 10,
                    renderCell: (params) => {
                        return <MoneyTextFormat value={params.row.sum} />
                    }
                }
            ]} rows={[...Object.keys(ExpenseMap).map((m) => {
                return {
                    id: ExpenseMap[m],
                    planned: (() => {
                        const exp = finances.expenses.find((e) => e.type == m)

                        if (exp) {
                            var periods = exp.periods.filter((f) => year >= dayjs(f.start, 'YYYY-MM-DD').year() && (year <= dayjs(f.end, 'YYYY-MM-DD').year() || f.end == null))

                            return periods.reduce((prev, cur) => prev + cur.amount, 0)
                        }



                    })(),
                    sum: monzoMap[m] ? Math.abs(monzoTransactions.filter((f) => monzoMap[m].includes(f[6]) || monzoMap[m].includes(f[4])).filter((f) => dayjs(f[1], "DD/MM/YYYY").year() === Number(year)).reduce((prev, cur) => prev + Number(cur[7]), 0)) : 0
                }
            }),
            {
                id: 'Disposable',
                planned: remaining,
                sum: monzoMap['disposable'] ? Math.abs(monzoTransactions.filter((f) => monzoMap['disposable'].includes(f[6])).filter((f) => dayjs(f[1], "DD/MM/YYYY").year() === Number(year)).reduce((prev, cur) => prev + Number(cur[7]), 0)) : 0
            }]} />
        </Grid>
    </Grid>

}

export default Monzo